<template>
    <v-row justify="center" class="border-radius-3">
        <v-dialog v-model="dialog" persistent width="650" class="border-radius-3" hide-overlay>
            <v-card class="border-radius-3 pa-5" color="#e9f5f4">
                <v-row>
                    <v-col cols="3" class="d-flex justify-center align-self-center">
                        <div class="avatar-stars">
                            <Avatar :avatar="stUserAvatar" />
                        </div>
                    </v-col>
                    <v-col cols="9">
                        <v-card-title class=" d-flex justify-center"
                            ><span
                                class="titles text-h4 font-weight-medium primary--text py-3 d-flex justify-center"
                                >{{ greetWelcomeMessage }}</span
                            ></v-card-title
                        >
                        <v-card-subtitle class="px-5 "
                            ><span class="titles text-h6 font-weight-regular primary--text">{{
                                $t('initialTour.pre_modal_msg.msg_1')
                            }}</span></v-card-subtitle
                        >
                        <v-card-text class=""
                            ><span class="primary--text subtitle-1 text-body-1">{{
                                $t('initialTour.pre_modal_msg.msg_2')
                            }}</span></v-card-text
                        >
                    </v-col>
                </v-row>

                <v-card-actions class="d-flex justify-center">
                    <v-btn data-cy="continue-button-pre-poll" color="secondary px-15" large rounded @click="nextPass">{{
                        $t('initialTour.continue')
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
import { mapState, mapActions } from 'vuex'

import Avatar from './AvatarCore/Avatar.vue'
import initialReaderValidation from "../../mixins/InitialReaderValidation";

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    components: {
        Avatar,
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            stUserAvatar: (state) => state.userData.avatarSelected,
            survey: (state) => state.userData.survey,
            course: (state) => state.userData.user.course,
            diagnosticData: (state) => state.dashboard.testDiagnostic,
        }),
        greetWelcomeMessage() {
            // eslint-disable-next-line no-nested-ternary
            return `${this.$t('initialTour.excellent')} ${this.$utils.upperFirstLetter(this.user.firstname.split(' ')[0])}!`
        },
    },
    methods: {
        ...mapActions('dashboard', [
            'showInitialPoll',
            'mountDiagnostic',
            'showFinishPreferencesModal',
            'showDiagnosticTutorialModal',
            'showFinishOnBoardingModal',
        ]),
        nextPass() {
            this.showFinishPreferencesModal()
            if (!this.isInitialReader && this.survey) {
                this.showInitialPoll();
                return
            }
            if (!this.isInitialReader && this.diagnosticData.length > 0) {
                this.showDiagnosticTutorialModal();
                return
            }

            this.showFinishOnBoardingModal();
        },
    },
    mixins: [initialReaderValidation]
}
</script>
<style>
.avatar-stars {
    background: url(../../assets/img/effects/avatar-stars.svg) round;
}
</style>
